import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-lovable-post-action-bar',
    templateUrl: './lovable-post-action-bar.component.html',
    styleUrls: ['./lovable-post-action-bar.component.css'],
})
export class LovablePostActionBarComponent implements OnInit {
    private static nextGradId = 0;

    @Input() commentCount = 0;
    @Input() repostCount = 0;
    @Input() likeCount = 0;
    @Input() scoreCount = 0;

    @Input() liked = false;
    @Input() reposted = false;
    @Input() scored = false;
    @Input() bookmarked = false;

    isLiked = false;
    isReposted = false;
    isScored = false;
    isBookmarked = false;
    showRepostMenu = false;
    gradientId = '';

    ngOnInit(): void {
        this.gradientId = `lovable-score-grad-${LovablePostActionBarComponent.nextGradId++}`;
        this.isLiked = this.liked;
        this.isReposted = this.reposted;
        this.isScored = this.scored;
        this.isBookmarked = this.bookmarked;
    }

    toggleRepostMenu(event: Event): void {
        event.stopPropagation();
        this.showRepostMenu = !this.showRepostMenu;
    }

    closeRepostMenu(): void {
        this.showRepostMenu = false;
    }

    toggleReposted(): void {
        this.isReposted = !this.isReposted;
        this.showRepostMenu = false;
    }

    toggleLiked(event: Event): void {
        event.stopPropagation();
        this.isLiked = !this.isLiked;
    }

    toggleScored(event: Event): void {
        event.stopPropagation();
        this.isScored = !this.isScored;
    }

    toggleBookmarked(event: Event): void {
        event.stopPropagation();
        this.isBookmarked = !this.isBookmarked;
    }
}
